import { render, staticRenderFns } from "./storyInfo.vue?vue&type=template&id=7a10b916&scoped=true&"
import script from "./storyInfo.vue?vue&type=script&lang=js&"
export * from "./storyInfo.vue?vue&type=script&lang=js&"
import style0 from "./storyInfo.vue?vue&type=style&index=0&id=7a10b916&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a10b916",
  null
  
)

export default component.exports